import Joi from '@hapi/joi';
import { string } from 'yup';

/**
 * @deprecated use zCustom.hexColor({allowAlpha: false}) instead
 */
export const hexColorSchema = Joi.string().regex(/^#([0-9a-f]{3}){1,2}$/i);

/**
 * @deprecated use zCustom.hexColor({allowAlpha: false}) instead
 */
export const yupHexColor = string().matches(/^#([0-9a-f]{3}){1,2}$/i, 'invalid hex color');
